/*
* Kadenze.UserState
*
* Utility to manage the UserState data for the user account on the client-side (stateable_type = User)
* It is initialized on page load by calling Kadenze.UserState.init();
*
* getState - will get the current state, it can be queried within the onReady callback or any point thereafter
* setState - will update the state, once updated, it will fire the reload event which can be listened to via the onReload callback
*
*/
var isReady = false;
var userState = {};

var setUserState = function(data) {
  var request = new Kadenze.AjaxRequest({
    type: 'POST',
    url: Kadenze.Routes.user_states_path(),
    data: {user_state: {data: JSON.stringify(data)}}
  });

  request.done(function(data, status, xhr) {
    userState = data['user_state']['meta_data'];
    Window.triggerEvent('reload');
  });

  return request;
};

var getUserState = function() {
  var request = new Kadenze.AjaxRequest({
    type: 'GET',
    url: Kadenze.Routes.user_states_path()
  });

  request.done(function(data, status, xhr) {
    userState = data['user_state']['meta_data'];
  });

  return request;
};

export default {
  init: function() {
    console.log('Initializing UserState');
    _.extend(Window, Kadenze.EventSource); //add event handling capability
    getUserState().done(function() {
      Window.triggerEvent('ready');
      isReady = true;
    });
  },
  onReady: function(callback) {
    if (isReady) {
      callback();
    } else if (Window.addEventListener) {
      Window.addEventListener('ready', function() {
        if(typeof callback === 'function') {
          callback();
        }
      });
    }
  },
  onReload: function(callback) {
    if (Window.addEventListener) {
      Window.addEventListener('reload', function() {
        if(typeof callback === 'function') {
          callback();
        }
      });
    }
  },
  getState: function () {
    return userState;
  },
  setState: function(data) {
    return setUserState(data);
  }
};
